const axios = require('axios');

class Api extends Error {
  constructor(message) {
    super(`ApiError: ${message}`);
  }
}

class Domain extends Error {
  constructor(message) {
    super(message);
  }
}

class ErrorMessage {
  message(error, msg) {
    if (axios.isAxiosError(error) && error.response) {
      const { status } = error.response;
      const data = error.response.data;
      const messageResponse = (data && typeof data === 'object' && (data.message || data.msg)) || msg;
      if (status >= 400 && status < 500) {
        return new Domain(messageResponse);
      }

      if (status >= 500) {
        return new Api(messageResponse);
      }
    }

    return new Error((error && error.message) || msg);
  }

  errorShow(error, msg = 'Erro desconhecido') {
    throw this.message(error, msg);
  }

  messageCustom(error, msg) {
    if (axios.isAxiosError(error) && error.response) {
      const data = error.response.data || {};
      const titleResponse = (typeof data === 'object' && data.title) || 'Erro';
      const messageResponse = (typeof data === 'object' && (data.message || data.msg)) || msg;
      return {
        title: titleResponse,
        message: messageResponse,
      };
    }

    return {
      title: 'Erro não identificado',
      message: msg,
    };
  }
}

module.exports = { Api, Domain, ErrorMessage };
